import React from 'react';

import { ISiteUserInfo } from '../../models/ISiteUserInfo';

export type AuthenticationProviderFunction = (user: ISiteUserInfo) => {name: string, isEnabled: boolean};

export const SiteUserAuthenticationProviderContext: React.Context<AuthenticationProviderFunction>
  = React.createContext<AuthenticationProviderFunction>(undefined);
